import React from 'react';
import classNames from 'classnames';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import { useDispatch } from 'react-redux';

import { Row as RowInterface } from '../../../Interface/Hook/Interest/InterestTableDTO';

import { getDeviationColor } from '../../../Helpers/Color';
import { scopeToggled } from '../../../Store/Scope/action';
import { useIsScopeClosed } from '../../../Hook/Interest/UseIsScopeClosed';

interface Props {
    data: RowInterface;
}

const ScopeRow: React.FC<Props> = ({ data }) => {
    const dispatch = useDispatch();
    const scope = data.cells[0].value as string;
    const scopeClosed = useIsScopeClosed(scope);

    const handleClick = (): void => {
        dispatch(scopeToggled(scope));
    };

    return (
        <tr className={classNames('scope', getDeviationColor(data.cells))} data-testid="table-row">
            <td colSpan={data.cells.length}>
                <span>
                    {scopeClosed ? <ChevronDown onClick={handleClick} /> : <ChevronUp onClick={handleClick} />}
                    {scope}
                </span>
            </td>
        </tr>
    );
};

export default ScopeRow;
